// SHADOW NETWORK · Monthly prize marquee banner.
// Rendered just below the (fixed) Navbar on /shadow — additive only.
import React from "react";

const TEXTS = {
  es:
    "🏆 Premios Mensuales · " +
    "🥇 1º Lugar → 300 USDC · " +
    "🥈 2º Lugar → 200 USDC · " +
    "🥉 3º Lugar → 100 USDC · " +
    "🎖️ 4º Lugar → 50% de descuento en SHADOW MARKET™ · " +
    "🎖️ 5º Lugar → 25% de descuento en SHADOW MARKET™ · ",
  en:
    "🏆 Monthly Prizes · " +
    "🥇 1st Place → 300 USDC · " +
    "🥈 2nd Place → 200 USDC · " +
    "🥉 3rd Place → 100 USDC · " +
    "🎖️ 4th Place → 50% off SHADOW MARKET™ · " +
    "🎖️ 5th Place → 25% off SHADOW MARKET™ · ",
  sk:
    "🏆 Mesačné Ceny · " +
    "🥇 1. Miesto → 300 USDC · " +
    "🥈 2. Miesto → 200 USDC · " +
    "🥉 3. Miesto → 100 USDC · " +
    "🎖️ 4. Miesto → 50% zľava v SHADOW MARKET™ · " +
    "🎖️ 5. Miesto → 25% zľava v SHADOW MARKET™ · ",
  de: "🏆 Monatliche Preise · " +
    "🥇 1. Platz → 300 USDC · " +
    "🥈 2. Platz → 200 USDC · " +
    "🥉 3. Platz → 100 USDC · " +
    "🎖️ 4. Platz → 50% Rabatt auf SHADOW MARKET™ · " +
    "🎖️ 5. Platz → 25% Rabatt auf SHADOW MARKET™ · ",
  "zh-CN": "🏆 月度奖励 · " +
    "🥇 第1名 → 300 USDC · " +
    "🥈 第2名 → 200 USDC · " +
    "🥉 第3名 → 100 USDC · " +
    "🎖️ 第4名 → SHADOW MARKET™ 50%折扣 · " +
    "🎖️ 第5名 → SHADOW MARKET™ 25%折扣 · "
};

export const PremiosBanner = ({ lang = "es" }) => {
  const text = TEXTS[lang] || TEXTS.en || TEXTS.es;
  return (
    <div
      data-testid="premios-banner"
      // mt-[64px] md:mt-[72px] pushes us below the fixed Navbar so the
      // marquee doesn't slide BEHIND the buttons (which is what looked
      // visually broken).
      className="relative mt-[64px] md:mt-[72px]"
      style={{
        background: "linear-gradient(90deg, rgba(7,8,15,1) 0%, rgba(13,14,28,1) 50%, rgba(7,8,15,1) 100%)",
        borderTop: "1px solid rgba(245,166,35,0.18)",
        borderBottom: "1px solid rgba(245,166,35,0.18)",
        overflow: "hidden",
        whiteSpace: "nowrap",
        padding: "10px 0",
        zIndex: 30,
      }}
    >
      <style>{`
        @keyframes premios-marquee {
          from { transform: translate3d(0, 0, 0); }
          to   { transform: translate3d(-50%, 0, 0); }
        }
        .premios-marquee-inner {
          display: inline-block;
          animation: premios-marquee 90s linear infinite;
          will-change: transform;
        }
        .premios-marquee-inner:hover { animation-play-state: paused; }
        @media (max-width: 640px) {
          .premios-marquee-inner { animation-duration: 70s; }
        }
      `}</style>
      <div
        className="premios-marquee-inner"
        style={{
          fontFamily: "'Courier New', monospace",
          fontSize: 13,
          fontWeight: 600,
          letterSpacing: "0.04em",
          color: "#f5a623",
          textShadow: "0 0 12px rgba(245,166,35,0.25)",
        }}
      >
        {text}
        {text}
      </div>
    </div>
  );
};

export default PremiosBanner;
